import { makeObservable, observable, action } from "mobx";
import { DialogProps } from "../Dialog";
import {
  ConfirmDialogProps,
  closeConfirmDialog,
  openConfirmDialog,
} from "../ConfirmDialog";

export type Dialog = DialogProps;

type DialogsState = Dialog[];

export class DialogStore {
  public dialogs = [] as DialogsState;
  constructor() {
    makeObservable(this, {
      dialogs: observable,
      setDialogs: action,
    });
  }

  public setDialogs = (dialogs: Dialog[]) => {
    this.dialogs = dialogs;
  };

  public openDialog = (dialog: Dialog, replace: boolean = false) => {
    const hasDialog = this.dialogs.some((d) => d.id === dialog.id);
    if (replace && hasDialog) {
      this.replaceDialog(dialog);
    } else {
      if (!hasDialog) {
        this.dialogs.push({ ...dialog });
      }
    }
  };

  public replaceDialog = (dialog: Dialog) => {
    // Ugly, need to make better.
    this.closeDialog(dialog.id);
    setTimeout(() => {
      this.openDialog(dialog);
    }, 100);
  };

  public closeDialog = (id: string, options?: any) => {
    const newDialogs = this.dialogs.filter(
      (dialog) => dialog.id !== id && dialog.parentDialogId !== id
    );
    this.setDialogs(newDialogs);
    if (!!options) {
      options();
    }
  };

  public openConfirmDialog = (props: ConfirmDialogProps) => {
    openConfirmDialog(props);
  };

  public closeConfirmDialog = (dialogId: string) => {
    closeConfirmDialog(dialogId);
  };
}

export const dialogStore = new DialogStore();
